import { Component, ElementRef, OnInit, Renderer2 } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { WorldlineService } from "./../../shared/services/worldline/worldline.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "environments/environment";

declare var $: any; // Declare $ as a global variable
declare const pnCheckoutShared: any;

@Component({
  selector: "app-worldline-customer-pay",
  templateUrl: "./worldline-customer-pay.component.html",
  styleUrls: ["./worldline-customer-pay.component.scss"],
})
export class WorldlineCustomerPayComponent implements OnInit {
  AuthUrl = environment.AuthURL;
  worldLineForm: FormGroup;
  worldlineToken: any;
  worldlinetxnId: any;
  checked: any = false;
  consumerID: any;
  paymentMode: any;
  note: boolean = false;
  isInsured: boolean = false;
  isUninsured: boolean = false;
  consumerData: any;
  readonly: boolean;
  id: any;
  organizationName: string;
  tatkaalMerchantId: string;
  tatkaalSaltKey: string;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private service: WorldlineService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.organizationName = sessionStorage.getItem("organizationName");
  }

  ngOnInit(): void {
    // debugger;
    this.route.queryParams.subscribe((parsam) => {
      this.id = JSON.parse(atob(parsam.data));
      // this.consumerData = null
      // console.log("This.Consumer Data :- ",this.consumerData);
      // this.checked = this.consumerData.checked;
      // if (this.consumerData.isUninsured) {
      //   this.isInsured = false;
      //   this.isUninsured = true;
      // } else if (this.consumerData.isInsured) {
      //   this.isInsured = true;
      //   this.isUninsured = false;
      // }
    });
    this.getWorldLineFormDatabyId();
    this.worldLineForm = this.formBuilder.group({
      name: ["",Validators.compose([
        Validators.required,
        Validators.pattern(/^[a-zA-Z ]*$/),
      ]),],
      consumerEmailId: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/),
        ]),
      ],
      consumerMobileNo: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("[0-9]{10}"),
        ]),
      ],
      totalamount: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[0-9]\d*$/),
        ]),
      ],
      patientName: ["", Validators.compose([
        Validators.required,
        Validators.pattern(/^[a-zA-Z ]*$/),
      ]),],
      paymentMode: ["", Validators.required],
      caseType: [""],
    });

    this.loadScript(
      "https://www.paynimo.com/paynimocheckout/server/lib/checkout.js",
      () => {
        // Script loaded callback
        // this.initPaynimoCheckout();
      }
    );
  }

  getWorldLineFormDatabyId() {
    // debugger;
    this.service.getWorldLineFormDatabyId(this.id).subscribe(
      async (res: any) => {
        if (res.status) {
          this.consumerData = res.formdata;
          this.patchWorldlineFormData();
          if (
            this.consumerData.organizationName == "Ayu Health" ||
            this.consumerData.organizationName == "AyuHealth"
          ) {
            (this.tatkaalMerchantId = "L998205"),
              (this.tatkaalSaltKey = "2517652273AASRLF");
          } else {
            (this.tatkaalMerchantId = "L1001266"),
              (this.tatkaalSaltKey = "5309099237TKPHHX");
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.service.ErrorSuccess(err.message);
      }
    );
  }

  patchWorldlineFormData() {
    if (this.consumerData.caseType == "Uninsured") {
      this.isInsured = false;
      this.isUninsured = true;
    } else if (this.consumerData.caseType == "Insured") {
      this.isInsured = true;
      this.isUninsured = false;
    }
    this.worldLineForm.patchValue({
      name: this.consumerData.name,
      consumerEmailId: this.consumerData.consumerEmailId,
      consumerMobileNo: this.consumerData.consumerMobileNo,
      totalamount: this.consumerData.totalamount,
      patientName: this.consumerData.patientName
        ? this.consumerData.patientName
        : this.consumerData.name,
      paymentMode: this.consumerData.paymentMode,
      caseType: this.consumerData.caseType,
    });
  }

  get mobRequired() {
    return this.worldLineForm.controls;
  }
  // get blockAmount() {
  //   return this.worldLineForm.controls;
  // }

  cardCheck(value) {
    if (value == "cards") {
      this.note = true;
    } else {
      this.note = false;
    }
  }

  checkInsured(value) {
    this.isInsured = value;
    this.isUninsured = false;
    this.worldLineForm.patchValue({
      caseType: "Insured",
    });
  }

  checkUninsured(value) {
    this.isUninsured = value;
    this.isInsured = false;
    this.worldLineForm.patchValue({
      caseType: "UnInsured",
    });
  }

  checkrelation1(value) {
    this.checked = value;
    if (this.checked) {
      this.worldLineForm.controls.name.setValidators([]);
      this.worldLineForm.controls.name.updateValueAndValidity();
    } else {
      this.worldLineForm.controls.name.setValidators([Validators.required]);
      this.worldLineForm.controls.name.updateValueAndValidity();
    }
  }

  loadScript(src: string, callback: () => void): void {
    const script = this.renderer.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.onload = callback;
    this.renderer.appendChild(this.el.nativeElement, script);
  }

  // initPaynimoCheckout(): void {
  //   const handleResponse = (res: any) => {
  //     // Your handleResponse logic here
  //   };

  //   const btnSubmit = this.el.nativeElement.querySelector('#btnSubmit');
  //   btnSubmit.addEventListener('click', (e: Event) => {
  //     e.preventDefault();

  //    var reqJson = {
  //                   "features": {
  //                       "enableAbortResponse": true,
  //                       "enableExpressPay": true,
  //                       "enableInstrumentDeRegistration" : true,
  //                       "enableMerTxnDetails": true,
  //                       "enableNewWindowFlow": true    //for hybrid applications please disable this by passing false
  //                   },
  //                   "consumerData": {
  //                       "deviceId": "WEBSH1",    //possible values "WEBSH1" or "WEBSH2"
  //                       "token": "594d88c4b38d375c6daa80755ec6f43fa2f2917c491611d29621de7fe8ad8e78",
  //                       "returnUrl": "http://localhost:3061/api/worldLine/callBackApiWorldLine",    //merchant response page URL
  //                       "responseHandler": handleResponse,
  //                       "paymentMode": "all",
  //                       "merchantLogoUrl": "http://localhost:4200/assets/images/Login/logo.png",  //provided merchant logo will be displayed
  //                       "merchantId": "L993998",
  //                       "currency": "INR",
  //                       "consumerId": "12345",
  //                       "consumerMobileNo": "7222938282",
  //                       "consumerEmailId": "rubenlezarus19@gmail.com",
  //                       "txnId": "1701768351991",   //Unique merchant transaction ID
  //                       "items": [{
  //                           "itemId": "FIRST",
  //                           "amount": "1",
  //                           "comAmt": "0"
  //                       }],
  //                       "customStyle": {
  //                           "PRIMARY_COLOR_CODE": "#45beaa",   //merchant primary color code
  //                           "SECONDARY_COLOR_CODE": "#FFFFFF",   //provide merchant's suitable color code
  //                           "BUTTON_COLOR_CODE_1": "#2d8c8c",   //merchant's button background color code
  //                           "BUTTON_COLOR_CODE_2": "#FFFFFF"   //provide merchant's suitable color code for button text
  //                       }
  //                   }
  //               };
  //     $.pnCheckout(reqJson);
      // debugger
  //     if (reqJson.features.enableNewWindowFlow) {
  //       pnCheckoutShared.openNewWindow();
  //     }
  //   });
  // }

  onSubmit() {
    console.log("this.worldLineForm.value", this.worldLineForm.value);
    if (this.checked) {
      this.worldLineForm.patchValue({
        name: this.worldLineForm.value.patientName,
      });
    }
    // return
    this.service.worldLineHash(this.worldLineForm.value).subscribe(
      (res) => {
        if (res["success"]) {
          // debugger;
          // this.service.showToaster("User Found Successfully");
          this.worldlineToken = res["encryptedResponse"];
          this.worldlinetxnId = res["txnId"];
          this.consumerID = res["consumerId"];
          this.paymentMode = res["transactionType"];
          console.log("this.worldlineToken", this.worldlineToken);
          this.proceedtopay();
        } else {
          this.service.ErrorSuccess(res["message"]);
        }
      },
      (err) => {
        this.service.ErrorSuccess(err.error["errorMessage"]);
        return;
      }
    );
  }

  proceedtopay() {
    // debugger;
    const handleResponse = (res: any) => {
      console.log(res);
      // debugger;
      if (res?.paymentMethod?.paymentTransaction?.statusCode === "0300") {
        // success block
        // debugger;
        this.router.navigate(["/Admin/Payment/Worldline-List"]);
      } else if (
        res?.paymentMethod?.paymentTransaction?.statusCode === "0398"
      ) {
        // initiated block
      } else {
        // error block
      }
    };

    var reqJson = {
      features: {
        enableAbortResponse: true,
        enableExpressPay: true,
        enableInstrumentDeRegistration: true,
        enableMerTxnDetails: true,
        enableNewWindowFlow: true, //for hybrid applications please disable this by passing false
      },
      consumerData: {
        deviceId: "WEBSH1", //possible values "WEBSH1" or "WEBSH2"
        token: this.consumerData.encryptedResponse,
        returnUrl: `${this.AuthUrl}/api/worldLine/callBackApiWorldLineforUsers`, //UAT merchant response page URL
        // "returnUrl": "http://localhost:3061/api/worldLine/callBackApiWorldLineforUsers",    //PROD merchant response page URL
        responseHandler: handleResponse,
        paymentMode: "cards",
        merchantLogoUrl:
          "https://portal.digisparsh.in/assets/images/Login/logo.png", //PROD provided merchant logo will be displayed
        merchantId: this.tatkaalMerchantId,
        // "merchantId": "T970265",
        currency: "INR",
        consumerId: undefined,
        consumerMobileNo: this.consumerData.consumerMobileNo,
        consumerEmailId: this.consumerData.consumerEmailId,
        txnId: this.consumerData.worldlinetxnId,
        // "PGtxnId": '199175690' ,                  //this.worldlinetxnId,
        txnType: "AUTH", //"CAPTURE" , // Unique merchant transaction ID
        items: [
          {
            itemId: "FIRST",
            amount: this.consumerData.totalamount,
            comAmt: "0",
          },
        ],
        customStyle: {
          PRIMARY_COLOR_CODE: "#45beaa", //merchant primary color code
          SECONDARY_COLOR_CODE: "#FFFFFF", //provide merchant's suitable color code
          BUTTON_COLOR_CODE_1: "#2d8c8c", //merchant's button background color code
          BUTTON_COLOR_CODE_2: "#FFFFFF", //provide merchant's suitable color code for button text
        },
      },
    };

    $.pnCheckout(reqJson);
    console.log("pnCheckout", reqJson);
    // debugger;
    if (reqJson.features.enableNewWindowFlow) {
      // debugger;
      pnCheckoutShared.openNewWindow();
      // debugger;
    }

    if (handleResponse) {
      console.log("Working PAYMENT Method");
    }
  }
}
